import React from 'react'
import map from 'lodash/map'
import { ButtonGroup } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import { BlogListViewModeEnum } from './BlogListViewModeEnum'

const viewModes = [
  { mode: BlogListViewModeEnum.Grid, icon: 'th-large', label: 'Grid view' },
  { mode: BlogListViewModeEnum.List, icon: 'list', label: 'List view' },
  { mode: BlogListViewModeEnum.Tree, icon: 'sitemap', label: 'Tree view' },
]

export type BlogViewToggleProps = {
  viewMode: BlogListViewModeEnum
  setViewMode: (mode: BlogListViewModeEnum) => void
}

export const BlogViewToggle = ({ viewMode, setViewMode }: BlogViewToggleProps) => (
  <ButtonGroup>
    {map(viewModes, ({ mode, icon, label }) => (
      <BusyButton
        key={mode}
        icon={icon}
        title={label}
        aria-label={label}
        variant={viewMode === mode ? 'primary' : 'outline-secondary'}
        active={viewMode === mode}
        onClick={() => setViewMode(mode)}
      />
    ))}
  </ButtonGroup>
)
